import type { PsfPromoteOrSharePageState } from './types';

export const mutations = {
	setMoreWaysExpanded: (state: PsfPromoteOrSharePageState, moreWaysExpanded: boolean): PsfPromoteOrSharePageState => ({
		...state,
		moreWaysExpanded,
	}),
};
